<app-acciones-contrato [idContrato]="contratoDetailDto.id"
  [contratoDetailDto]="contratoDetailDto"></app-acciones-contrato>
<mat-tab-group animationDuration="0ms">

  <!-- Detalle/Seguimiento -->
  <mat-tab class="position-relative">
    <ngx-spinner [zIndex]=100 name="spContrato" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
      type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">zoom_in </mat-icon> &nbsp; Detalle/Seguimiento
    </ng-template>
    <form [formGroup]="detalleMontosContratorFormGroup" class="container-mat-card">
      <ng-template matStepLabel>Detalle Montos contrato</ng-template>
      <div class="row">
        <div class="col-lg-7">
          <mat-card *ngIf="contratoDetailDto">

            <mat-card-content>
              <div class="row">
                <div class="col-10">
                  <mat-card-header>
                    <mat-card-title>Contrato nro.: {{contratoDetailDto.numeroContrato}}</mat-card-title>
                  </mat-card-header>
                </div>
                <div class="col-2">

                  <app-badge-estados-contrato [idEstado]="contratoDetailDto.id"
                    [descripcionEstado]="contratoDetailDto.estadoContrato?.descripcion">
                  </app-badge-estados-contrato>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 montoscontrato">
                      <mat-label><b>Tipo Contrato: </b></mat-label>
                      <span>{{isFalsy(contratoDetailDto.tipoContrato) ? "" :
                        contratoDetailDto.tipoContrato?.descripcion}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 montoscontrato">
                      <mat-label><b>Fecha Comienzo: </b></mat-label>
                      <span class="badge bg-success text-light">{{contratoDetailDto.fechaComienzo |
                        date:('dd/MM/yyyy')}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Día Vencimiento Pago - Vista/Edición -->
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 montoscontrato">

                      <!-- Modo Vista -->
                      <div *ngIf="!modoEdicionDiaVto">
                        <mat-label><b>Día Vto. Pago: </b></mat-label>
                        <span>{{contratoDetailDto.diaVencimientoPago}}</span>
                        <button mat-icon-button *appRole="['Contratos.Modificar']" (click)="activarEdicionDiaVto()"
                          matTooltip="Editar día de vencimiento" color="primary">
                          <mat-icon *ngIf="!modoEdicionDiaVto">edit</mat-icon>
                        </button>

                      </div>

                      <!-- Modo Edición -->
                      <div *ngIf="modoEdicionDiaVto">
                        <mat-form-field class="dia-vto-field">
                          <ngx-spinner [zIndex]="1" name="spUpdateContrato" bdColor="rgba(255,255,255,0.8)" size="small"
                            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                          <mat-label>Día Vto. Pago</mat-label>
                          <input matInput type="number" min="1" max="28" [(ngModel)]="diaVencimientoPagoTemp"
                            [ngModelOptions]="{standalone: true}">
                          <mat-error>Ingrese un día entre 1 y 31</mat-error>
                        </mat-form-field>

                        <div class="edit-actions">
                          <button mat-icon-button color="primary" (click)="guardarDiaVencimiento()"
                            matTooltip="Guardar">
                            <mat-icon>check</mat-icon>
                          </button>
                          <button mat-icon-button (click)="cancelarEdicionDiaVto()" matTooltip="Cancelar">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-12 montoscontrato">
                      <mat-label><b>Fecha Finalización: </b></mat-label>
                      <span class="badge bg-danger text-light">{{contratoDetailDto.fechaVencimiento |
                        date:('dd/MM/yyyy')}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <mat-label><b>Tipo Ajuste: </b></mat-label>
                      <span>{{contratoDetailDto.tipoAjusteContrato?.descripcion}}
                        ({{contratoDetailDto.tipoAjusteContrato?.acronimo}})</span>
                    </div>
                  </div>
                </div>
                <div class="col-6" *ngIf="contratoDetailDto.fechaResicion != ''">
                  <div class="row">
                    <div class="col-12 montoscontrato">
                      <mat-label><b>Fecha Rescisión: </b></mat-label>
                      <span class="badge bg-danger text-light">{{contratoDetailDto.fechaResicion |
                        date:('dd/MM/yyyy')}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 montoscontrato">
                      <mat-label><b>Frecuencia ajuste: </b></mat-label>
                      <span>{{contratoDetailDto.frecuenciaAjusteMensual}} <span
                          *ngIf="contratoDetailDto.frecuenciaAjusteMensual">meses</span></span>
                    </div>
                  </div>
                </div>
              </div>

            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-lg-5">
          <mat-card>
            <mat-card-content>
              <div class="row">
                <ngx-spinner [zIndex]="1" name="spInquilino" bdColor="rgba(255,255,255,0.8)" size="small"
                  color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <div class="col-12">
                  <mat-label><b>Inquilino:</b></mat-label>
                  <span>{{personaInquilino.nombreCompleto | titlecase}}
                    <button mat-icon-button matTooltip="Editar inquilino"
                      *ngIf="personaInquilino.nombreCompleto != '' && personaInquilino?.id"
                      (click)="editarPersona(personaInquilino.id)" color="primary">
                      <mat-icon>rate_review</mat-icon>
                    </button>
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-12 montoscontrato">
                  <ngx-spinner [zIndex]="1" name="spDatosPropietarios" bdColor="rgba(255,255,255,0.8)" size="small"
                    color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                  <mat-label><b>Propietario: </b>
                    <span *ngFor="let propietario of propietariosPropiedad;let i=index;trackBy:trackByItems">
                      {{propietario.persona?.descripcion}}
                      <button mat-icon-button
                        *ngIf="propietario.persona && propietariosPropiedad.length > 0 && propietario?.persona"
                        (click)="editarPersona(propietario.persona.id)" matTooltip="Editar propietario" color="primary">
                        <mat-icon>rate_review</mat-icon>
                      </button>
                    </span>
                  </mat-label>
                </div>
              </div>

              <div class="row">
                <div class="col-12 montoscontrato">
                  <ngx-spinner [zIndex]="1" name="spDatosPropiedad" bdColor="rgba(255,255,255,0.8)" size="small"
                    color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                  <mat-label><b>Propiedad: </b></mat-label>
                  <span>{{propiedad.ubicacion | titlecase}},&nbsp;
                    {{propiedad.localidad != undefined ? propiedad.localidad?.descripcion: "" | titlecase}}
                    <button mat-icon-button matTooltip="Editar propiedad"
                      *ngIf="propiedad && propiedad.ubicacion != '' && propiedad?.id"
                      (click)="editarPropiedad(propiedad.id)" color="primary">
                      <mat-icon>rate_review</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </form>
  </mat-tab>

  <!-- Propiedad -->
  <mat-tab class="position-relative">
    <ngx-spinner [zIndex]=100 name="spDatosPropiedad" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
      type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">roofing </mat-icon>&nbsp; Propiedad
    </ng-template>

    <div class="container-mat-card">
      <ng-template matStepLabel>Datos propiedad</ng-template>
      <div class="row" *ngIf="propiedad">
        <div class="col-6">
          <mat-card>

            <mat-card-header>
              <mat-card-title>Información Propiedad</mat-card-title>
            </mat-card-header>
            <mat-card-content>

              <div class="row">
                <div class="col-6" *ngIf="propiedad.estadoPropiedad">
                  <mat-label><b>Estado: </b></mat-label><span>{{isFalsy(propiedad.estadoPropiedad) ? "" :
                    propiedad.estadoPropiedad?.descripcion| titlecase}}</span>
                </div>
                <div class="col-6">
                  <mat-label><b>Fecha alta: </b></mat-label> <span>{{propiedad.fechaAlta | date:'dd/MM/yyyy'}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-6" *ngIf="propiedad.tipoPropiedad">
                  <mat-label><b>Tipo: </b></mat-label><span>{{isFalsy(propiedad.tipoPropiedad) ? "":
                    propiedad.tipoPropiedad?.descripcion | titlecase}}</span>
                </div>
                <div class="col-6" *ngIf="propiedad.subtipoPropiedad">
                  <mat-label><b>Subtipo: </b></mat-label> <span>{{isFalsy(propiedad.subtipoPropiedad) ? "":
                    propiedad.subtipoPropiedad?.descripcion| titlecase}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <mat-label><b>Localidad: </b></mat-label><span>{{isFalsy(propiedad.localidad) ? "":
                    propiedad.localidad?.descripcion| titlecase}}</span>
                </div>
                <div class="col-6" *ngIf="propiedad.estadoPropiedad">
                  <mat-label><b>Ubicación: </b></mat-label>
                  {{propiedad.ubicacion | titlecase}}
                  <span *ngIf="propiedad.piso">{{propiedad.piso | uppercase}}</span>
                  <span> </span>
                  <span *ngIf="propiedad.departamento"> {{isFalsy(propiedad.departamento)? "" : propiedad.departamento |
                    uppercase}}</span>

                  <span>
                    <button matSuffix mat-icon-button matTooltip="Editar propiedad"
                      *ngIf="propiedad.ubicacion!= '' && propiedad.id" (click)="editarPropiedad(propiedad.id)"
                      color="primary">
                      <mat-icon>rate_review</mat-icon>
                    </button></span>

                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-6">
          <mat-card>
            <ngx-spinner [zIndex]=100 name="spDatosPropietarios" bdColor="rgba(255,255,255,0.8)" size="default"
              color="#009688" type="ball-atom" [fullScreen]="false">
            </ngx-spinner>

            <!-- Botón editar en esquina superior -->
            <button mat-icon-button class="edit-button-top-right" *appRole="['Contratos.Modificar']"
              (click)="activarEdicionPropietario()" matTooltip="Editar información del propietario" color="primary">
              <mat-icon *ngIf="!modoEdicionPropietario && contratoDetailDto">edit</mat-icon>
            </button>

            <mat-card-header>
              <mat-card-title>Información Propietarios</mat-card-title>
            </mat-card-header>

            <mat-card-content *ngFor="let propietario of propietariosPropiedad; let i=index; trackBy:trackByItems">
              <mat-accordion class="example-headers-align">
                <!-- Expandir automáticamente si es titular -->
                <mat-expansion-panel [expanded]="propietario.titular">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span>{{propietario.persona?.descripcion | titlecase}}
                        <button mat-icon-button matTooltip="Editar persona"
                          *ngIf="propietario && propietario.persona && propietario.persona.descripcion != '' && propietario?.persona?.id"
                          (click)="editarPersona(propietario.persona.id)" color="primary">
                          <mat-icon>rate_review</mat-icon>
                        </button>
                      </span>
                    </mat-panel-title>
                    <mat-panel-description>
                      Propietario titular
                      <mat-icon *ngIf="propietario.titular == true">account_circle</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <!-- Modo Vista (Solo lectura) -->
                  <div *ngIf="!modoEdicionPropietario && propietario.titular == true">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="info-field">
                          <strong>Comisión:</strong>
                          <span class="value">
                            {{isFalsy(contratoDetailDto.porcentajeComisionPropietario) ? "No definido" :
                            contratoDetailDto.porcentajeComisionPropietario + '%'}}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="info-field">
                          <strong>Forma de Pago:</strong>
                          <span class="value">
                            {{isFalsy(contratoDetailDto.formaPagoPropietario) ? "No definido" :
                            contratoDetailDto.formaPagoPropietario?.descripcion}}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="info-field">
                          <strong>Tipo Liquidación:</strong>
                          <span class="value">
                            {{isFalsy(contratoDetailDto.tipoLiquidacion?.descripcion) ? "No definido" :
                            contratoDetailDto.tipoLiquidacion?.descripcion | titlecase}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Modo Edición -->
                  <div *ngIf="modoEdicionPropietario && propietario.titular == true">
                    <form [formGroup]="propietarioEditForm">
                      <ngx-spinner [zIndex]="1" name="spUpdateContrato" bdColor="rgba(255,255,255,0.8)" size="small"
                        color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <div class="row">
                        <div class="col-md-4">
                          <mat-form-field class="full-width">
                            <mat-label>Comisión</mat-label>
                            <input matInput type="number" min="0" max="100" step="0.01" formControlName="comision">
                            <span matSuffix>%</span>
                            <mat-error *ngIf="propietarioEditForm.get('comision')?.hasError('required')">
                              Campo requerido
                            </mat-error>
                            <mat-error *ngIf="propietarioEditForm.get('comision')?.hasError('min')">
                              Debe ser mayor o igual a 0
                            </mat-error>
                            <mat-error *ngIf="propietarioEditForm.get('comision')?.hasError('max')">
                              No puede ser mayor a 100%
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col-md-4">
                          <mat-form-field class="full-width">
                            <ngx-spinner name="spFormaPago" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688"
                              type="line-scale" [fullScreen]="false">
                            </ngx-spinner>
                            <mat-label>Forma de Pago</mat-label>
                            <mat-select formControlName="formaPago">
                              <mat-option *ngFor="let forma of lstFormasPago; trackBy: trackByItems" [value]="forma.id">
                                {{forma.descripcion}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="propietarioEditForm.get('formaPago')?.hasError('required')">
                              Campo requerido
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col-md-4">
                          <mat-form-field class="full-width">
                            <ngx-spinner name="spTipoLiquidacion" bdColor="rgba(255,255,255,0.8)" size="small"
                              color="#009688" type="line-scale" [fullScreen]="false">
                            </ngx-spinner>
                            <mat-label>Tipo Liquidación</mat-label>
                            <mat-select formControlName="tipoLiquidacion">
                              <mat-option *ngFor="let tipo of lstTiposLiquidacion; trackBy: trackByItems"
                                [value]="tipo.id">
                                {{tipo.descripcion}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="propietarioEditForm.get('tipoLiquidacion')?.hasError('required')">
                              Campo requerido
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Botones de acción -->
                      <div class="actions-row">
                        <button mat-stroked-button (click)="cancelarEdicionPropietario()">
                          <mat-icon>close</mat-icon>
                          Cancelar
                        </button>
                        <button mat-raised-button color="primary" [disabled]="!propietarioEditForm.valid"
                          (click)="guardarDatosPropietario()">
                          <mat-icon>save</mat-icon>
                          Guardar Cambios
                        </button>
                      </div>
                    </form>
                  </div>

                </mat-expansion-panel>
              </mat-accordion>
            </mat-card-content>

            <mat-card-content *ngIf="propietariosPropiedad?.length == 0">
              <span style="color: red;">Esta propiedad no tiene propietario!</span>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-tab>

  <!-- Inquilino -->
  <mat-tab class="position-relative">
    <ngx-spinner [zIndex]=100 name="spInquilino" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
      type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">vpn_key </mat-icon>&nbsp; Inquilino
    </ng-template>

    <div class="container-mat-card">
      <ng-template matStepLabel>Datos inquilino</ng-template>

      <div class="row">
        <div class="col-lg-7">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Información Inquilino</mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="personaInquilino">
              <div class="row">
                <div class="col-6">

                  <mat-label><b>Correo: </b></mat-label> <a *ngIf="personaInquilino.correo"
                    href="mailto:{{personaInquilino.correo | titlecase}}">
                    {{personaInquilino.correo}} </a>
                </div>
                <div class="col-6">
                  <mat-label><b>Nro. Documento: </b></mat-label><span>{{personaInquilino.nroDocumento}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <mat-label><b>Telefono principal: </b></mat-label>
                  <a *ngIf="personaInquilino.telefonoPrincial" href="tel:+54{{personaInquilino.telefonoPrincial}}">
                    <mat-icon inline>call</mat-icon>+54{{personaInquilino.telefonoPrincial}}
                  </a>
                </div>
                <div class="col-6">
                  <mat-label><b>Telefono alternativo: </b></mat-label> <a *ngIf="personaInquilino.telefonoAlternativo"
                    href="tel:+54{{personaInquilino.telefonoAlternativo}}">
                    +54{{personaInquilino.telefonoAlternativo}} </a>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <mat-label><b>Nombre: </b></mat-label> {{personaInquilino.nombreCompleto | titlecase}}
                  <button mat-icon-button matTooltip="Editar persona"
                    *ngIf="personaInquilino.nombreCompleto!= '' && personaInquilino.id"
                    (click)="editarPersona(personaInquilino.id)" color="primary">
                    <mat-icon>rate_review</mat-icon>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-lg-5">
          <mat-card>
            <ngx-spinner [zIndex]=100 name="spGarantia" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
              type="ball-atom" [fullScreen]="false">
            </ngx-spinner>
            <mat-card-header>
              <mat-card-title>Información Garantias</mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="tieneGarantias">
              <mat-card-content *ngFor="let garantia of contratoDetailDto.garantias;let i=index;trackBy:trackByItems">
                <mat-accordion class="example-headers-align">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span>{{garantia.persona?.descripcion | titlecase}}
                          <button mat-icon-button matTooltip="Editar persona"
                            *ngIf="garantia.persona.descripcion != '' && garantia.persona && garantia.persona.id"
                            (click)="editarPersona(garantia.persona.id)" color="primary">
                            <mat-icon>rate_review</mat-icon>
                          </button></span>
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="row">
                      <div class="col-6">
                        <mat-label><b>Tipo garantia: </b></mat-label><span>{{garantia.tipoGarantia?.descripcion |
                          titlecase}}</span>
                      </div>
                      <div class="col-6">
                        <mat-label><b>Estado: </b></mat-label> <span class="badge text-white"
                          [ngClass]="{'bg-success': garantia.activo==true,'bg-danger': garantia.activo!=true }">{{garantia.activo
                          == true ? 'Activo': "Inactivo" }}</span>

                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </mat-card-content>
              <mat-card-content *ngIf="contratoDetailDto.garantias?.length == 0">
                <div class="no-data-table">
                  <span style="color: red;" class="with-icon">
                    <mat-icon>warning_amber</mat-icon>Este inquilino no tiene garantias o no estan activas.
                  </span>
                </div>
              </mat-card-content>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-tab>

  <!-- Montos Contrato -->
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">attach_money</mat-icon>&nbsp; Montos Contrato
    </ng-template>

    <div class="container-mat-card">
      <ng-template matStepLabel>Datos inquilino</ng-template>

      <div class="row">

        <ngx-spinner [zIndex]=100 name="spContrato" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
          type="ball-atom" [fullScreen]="false">
        </ngx-spinner>
        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Montos Honorarios</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col">
                  <mat-label><b>Monto: </b> </mat-label><span>{{contratoDetailDto.montoAdministrativo}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col" *ngIf="contratoDetailDto.tipoMontoAdministrativo">
                  <mat-label><b>Tipo Monto: </b></mat-label>
                  <span>{{contratoDetailDto.tipoMontoAdministrativo?.descripcion}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-label><b>Plan de Pagos: </b></mat-label><span>{{contratoDetailDto.planDePago}}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Montos Punitorios</mat-card-title>
              <div class="spacer" style="flex: 1 1 auto;"></div>
              <div *appRole="['Contratos.Modificar']">
                <button mat-icon-button *ngIf="!modoEdicionPunitorios" (click)="activarEdicionPunitorios()"
                  matTooltip="Editar montos punitorios" color="primary">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </mat-card-header>


            <!-- Vista de Solo Lectura -->
            <mat-card-content *ngIf="!modoEdicionPunitorios">
              <div>
                <div *ngIf="contratoDetailDto.tipoPunitorio">
                  <mat-label><b>Tipo Punitorio: </b></mat-label><span>{{ contratoDetailDto.tipoPunitorio?.descripcion ||
                    'No definido' }}</span>
                </div>

                <div>
                  <mat-label><b>Punitorios (por día): </b></mat-label><span>{{ contratoDetailDto.montoPunitorio || 'No
                    definido' }}</span>
                </div>

                <div *ngIf="contratoDetailDto.tipoMontoPunitorio">
                  <mat-label><b>Tipo Monto: </b></mat-label><span>{{ contratoDetailDto.tipoMontoPunitorio?.descripcion
                    || 'No definido' }}</span>
                </div>
              </div>
            </mat-card-content>

            <!-- Formulario de Edición -->
            <mat-card-content *ngIf="modoEdicionPunitorios">
              <form [formGroup]="punitoriosForm">
                <ngx-spinner [zIndex]="1" name="spUpdateContrato" bdColor="rgba(255,255,255,0.8)" size="small"
                  color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <div class="form-section">
                  <div class="row">
                    <div class="col">
                      <!-- Tipo Punitorio -->
                      <mat-form-field class="full-width">
                        <ngx-spinner name="spTiposPunitorios" bdColor="rgba(255,255,255,0.8)" size="small"
                          color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                        <mat-label>Tipo Punitorio</mat-label>
                        <mat-select formControlName="tipoPunitorio" (selectionChange)="onTipoPunitorioChange($event)">
                          <mat-option *ngFor="let tipo of lstTiposPunitorio; trackBy: trackByItems" [value]="tipo">
                            {{ tipo.descripcion }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="punitoriosForm.get('tipoPunitorio')?.hasError('required')">
                          Este campo es requerido
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col">
                      <!-- Monto Punitorio -->
                      <mat-form-field class="full-width">
                        <span matPrefix>$&nbsp;</span>
                        <mat-label>Punitorios (por día)</mat-label>
                        <input matInput type="number" min="0" step="0.01" formControlName="montoPunitorio"
                          placeholder="0.00">
                        <mat-error *ngIf="punitoriosForm.get('montoPunitorio')?.hasError('required')">
                          Este campo es requerido
                        </mat-error>
                        <mat-error *ngIf="punitoriosForm.get('montoPunitorio')?.hasError('min')">
                          El monto debe ser mayor o igual a 0
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col">
                      <!-- Tipo Monto Punitorio -->
                      <mat-form-field class="full-width">
                        <ngx-spinner name="spTiposMontos" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688"
                          type="line-scale" [fullScreen]="false"></ngx-spinner>
                        <mat-label>Tipo Monto</mat-label>
                        <mat-select formControlName="tipoMontoPunitorio"
                          (selectionChange)="onTipoMontoPunitorioChange($event)">
                          <mat-option *ngFor="let tipoMonto of lstTiposMontoPunitorio; trackBy: trackByItems"
                            [value]="tipoMonto.id">
                            {{ tipoMonto.descripcion }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="punitoriosForm.get('tipoMontoPunitorio')?.hasError('required')">
                          Este campo es requerido
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>
            </mat-card-content>

            <!-- Acciones para modo edición -->
            <mat-card-actions *ngIf="modoEdicionPunitorios" align="end">
              <button mat-stroked-button (click)="cancelarEdicionPunitorios()">
                <mat-icon>cancel</mat-icon>
                Cancelar
              </button>
              <button mat-raised-button color="primary" [disabled]="!punitoriosForm.valid"
                (click)="guardarMontosPunitorios()">
                <mat-icon>save</mat-icon>
                Guardar
              </button>
            </mat-card-actions>

          </mat-card>
        </div>
        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Montos Sellado</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col">
                  <mat-label><b>Tipo Sellado:
                    </b></mat-label><span>{{contratoDetailDto.tipoSellado?.descripcion}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-label><b>Monto: </b></mat-label> <span>{{contratoDetailDto.montoSellado}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-label><b>Tipo Monto: </b></mat-label>
                  <span>{{contratoDetailDto.tipoMontoSellado?.descripcion}}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-tab>

  <!-- Detalle monto Contrato -->
  <mat-tab>
    <form [formGroup]="detalleMontosContratorFormGroup" class="container-mat-card">
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">account_balance </mat-icon>&nbsp; Detalle Montos Contrato
      </ng-template>

      <div class="row">
        <div class="col-12">
          <button mat-raised-button class="btn-margin" *appRole="['Contratos.AgregarPeriodos']"
            (click)="openDialogNuevoPeriodoComponent(false)" color="primary"
            [disabled]="contratoDetailDto.estadoContrato?.id != estadosContrato.Activo || (contratoDetailDto.estadoContrato?.id == estadosContrato.Activo && contratoDetailDto.tipoAjusteContrato?.id != tiposAjusteContrato.SIN)">
            <mat-icon>add</mat-icon>
            Cargar nuevos periodos
          </button>
          <button mat-stroked-button class="btn-margin" *appRole="['Contratos.Adendar']"
            (click)="openDialogAdendaContratoComponent(true)" color="primary"
            [disabled]="contratoDetailDto.estadoContrato?.id != estadosContrato.Activo">
            <mat-icon>next_plan</mat-icon>
            Adendar contrato

          </button>

          <button mat-stroked-button class="btn-margin" matTooltip="Recargar periodos"
            (click)="getPeriodosContratoByIdContrato(contratoDetailDto.id)" color="primary"
            [disabled]="contratoDetailDto.estadoContrato?.id != estadosContrato.Activo">
            <mat-icon>sync</mat-icon>
          </button>
          <br>
          <br>
          <div class="row">
            <div class="col-12">
              <mat-accordion class="example-headers-align">
                <ngx-spinner name="spPeriodosConstrato" [zIndex]=100 bdColor="rgba(255,255,255,0.8)" size="default"
                  color="#009688" type="ball-atom" [fullScreen]="false">
                </ngx-spinner>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Detalle Montos Contrato
                    </mat-panel-title>
                    <mat-panel-description>
                      Detalle de montos
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <!-- ============ RESUMEN DE COBRANZA Y LIQUIDACIÓN ============ -->
                  <div class="resumen-cobranza" *ngIf="data">

                    <!-- Cobranza al inquilino -->
                    <div class="resumen-grupo">
                      <div class="resumen-grupo-titulo">
                        <mat-icon color="primary">request_quote</mat-icon>
                        <span>Cobranza al inquilino</span>
                      </div>

                      <div class="resumen-items">
                        <div class="resumen-item">
                          <span class="resumen-label">Total devengado</span>
                          <span class="resumen-valor">{{ totalDevengado | currency }}</span>
                          <span class="resumen-ayuda">Períodos ya vencidos</span>
                        </div>

                        <div class="resumen-item">
                          <span class="resumen-label">Total cobrado</span>
                          <span class="resumen-valor ok">{{ totalPagado | currency }}</span>
                          <span class="resumen-ayuda">Con fecha de pago</span>
                        </div>

                        <div class="resumen-item">
                          <span class="resumen-label">Deuda del inquilino</span>
                          <span class="resumen-valor" [class.alerta]="deudaInquilino > 0">{{ deudaInquilino | currency }}</span>
                          <span class="resumen-ayuda">
                            Vencido e impago
                            <ng-container *ngIf="cantidadPeriodosEnMora > 0">
                              &mdash; {{ cantidadPeriodosEnMora }} período{{ cantidadPeriodosEnMora > 1 ? 's' : '' }}
                            </ng-container>
                          </span>
                        </div>

                        <div class="resumen-item">
                          <span class="resumen-label">Total a cobrar</span>
                          <span class="resumen-valor">{{ totalACobrar | currency }}</span>
                          <span class="resumen-ayuda">Impago, incluye no vencidos</span>
                        </div>
                      </div>
                    </div>

                    <!-- Liquidación al propietario -->
                    <div class="resumen-grupo resumen-grupo-propietario">
                      <div class="resumen-grupo-titulo">
                        <mat-icon color="primary">account_balance_wallet</mat-icon>
                        <span>Liquidación al propietario</span>
                      </div>

                      <div class="resumen-items">
                        <div class="resumen-item">
                          <span class="resumen-label">Total liquidado</span>
                          <span class="resumen-valor ok">{{ totalLiquidado | currency }}</span>
                          <span class="resumen-ayuda">Con fecha de liquidación</span>
                        </div>

                        <!-- El criterio sale del tipo de liquidación del contrato -->
                        <div class="resumen-item">
                          <span class="resumen-label">Total por liquidar</span>
                          <span class="resumen-valor" [class.alerta]="totalPorLiquidar > 0">{{ totalPorLiquidar | currency }}</span>
                          <span class="resumen-ayuda">
                            {{ esLiquidacionFicticia ? 'Devengado y sin liquidar' : 'Cobrado y sin liquidar' }}
                          </span>
                        </div>

                        <!-- En la ficticia lo impago ya entra en "por liquidar" -->
                        <div class="resumen-item" *ngIf="!esLiquidacionFicticia">
                          <span class="resumen-label">Devengado sin cobrar</span>
                          <span class="resumen-valor">{{ devengadoSinCobrarNiLiquidar | currency }}</span>
                          <span class="resumen-ayuda">Vencido, impago y sin liquidar</span>
                        </div>

                        <div class="resumen-item total-control">
                          <span class="resumen-label">Total períodos</span>
                          <span class="resumen-valor">{{ totalPeriodos | currency }}</span>
                          <span class="resumen-ayuda">Todos, vencidos y futuros</span>
                        </div>
                      </div>

                      <!-- Que el número dependa del tipo de contrato no puede quedar implícito -->
                      <div class="aviso-tipo-liquidacion">
                        <mat-icon>info_outline</mat-icon>
                        <span *ngIf="!esLiquidacionFicticia">
                          Liquidación <b>real</b>: sólo se le rinde al propietario lo que el inquilino pagó.
                        </span>
                        <span *ngIf="esLiquidacionFicticia">
                          Liquidación <b>ficticia</b>: se le rinde al propietario aunque el inquilino no haya pagado.
                        </span>
                      </div>

                      <!-- Apertura del total liquidado según si el inquilino llegó a pagar -->
                      <div class="resumen-subtitulo">Del total liquidado</div>

                      <div class="resumen-items">
                        <div class="resumen-item">
                          <span class="resumen-label">Liquidado y cobrado</span>
                          <span class="resumen-valor ok">{{ liquidadoYCobrado | currency }}</span>
                          <span class="resumen-ayuda">Se liquidó y el inquilino pagó</span>
                        </div>

                        <div class="resumen-item">
                          <span class="resumen-label">Liquidado sin cobrar</span>
                          <span class="resumen-valor" [class.alerta]="liquidadoSinCobrar > 0">{{ liquidadoSinCobrar | currency }}</span>
                          <span class="resumen-ayuda">Se liquidó y el inquilino no pagó</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <table mat-table [dataSource]="dataSource" matSort [hidden]=!data class="mat-elevation-z8">
                    <ng-container matColumnDef="periodo">
                      <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Periodo </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.periodo}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="periodoFecha">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.periodoMes}}/{{periodo.periodoAnio}}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="fechaPago">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Fecha Pago </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.fechaPago == "0001-01-01T00:00:00" ? "":
                        periodo.fechaPago | date:"dd/MM/yyyy"}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="fechaLiquidacion">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Fecha Liquidación </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.fechaLiquidacion == "0001-01-01T00:00:00"
                        ? "": periodo.fechaLiquidacion | date:"dd/MM/yyyy"}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="fechaAjuste">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Fecha Ajuste </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.fechaAjuste == "0001-01-01T00:00:00"
                        ? "": periodo.fechaAjuste | date:"dd/MM/yyyy"}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="importe">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Impote </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"> {{periodo.importeAlquiler | currency}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="indiceAjusteContrato">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Tipo Ajuste </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"><span
                          [matTooltip]="periodo.indiceAjusteContrato?.tipoAjusteContrato?.descripcion | titlecase ">
                          {{periodo.indiceAjusteContrato?.tipoAjusteContrato.acronimo | uppercase}}
                        </span> </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="valorAjuste">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Valor Ajuste </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo"><span>
                          {{periodo.valorAjuste | number:'1.3-3'}}
                        </span> </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="ajusteProcesado">
                      <mat-header-cell mat-header-cell *matHeaderCellDef>Procesado </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo">
                        <mat-icon color="primary"
                          *ngIf="periodo.ajusteProcesado == true">check_circle_outline</mat-icon>
                        <mat-icon color="warn" *ngIf="periodo.ajusteProcesado == false">highlight_off</mat-icon>
                      </mat-cell>
                    </ng-container>



                    <!-- Action Column -->
                    <ng-container matColumnDef="accion">
                      <mat-header-cell mat-header-cell *matHeaderCellDef> Acción </mat-header-cell>
                      <mat-cell mat-cell *matCellDef="let periodo" class="action-link">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="openDialog(periodo)" *appRole="['PeriodosContrato.Ver']">
                            <mat-icon>visibility</mat-icon>
                            <span>Ver</span>
                          </button>
                          <button mat-menu-item (click)="openDialogEditar(periodo)"
                            *appRole="['PeriodosContrato.Modificar']">
                            <mat-icon>edit</mat-icon>
                            <span>Editar</span>
                          </button>
                          <button mat-menu-item (click)="eliminarPeriodo(periodo)"
                            *appRole="['PeriodosContrato.Eliminar']">
                            <mat-icon>delete</mat-icon>
                            <span>Eliminar</span>
                          </button>
                        </mat-menu>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></mat-row>


                  </table>
                  <app-sin-datos *ngIf="dataSource.data?.length == 0"></app-sin-datos>
                  <mat-paginator showFirstLastButtons class="paginator" [pageSize]="50"
                    [pageSizeOptions]="[5, 10, 20,50,100,200]">
                  </mat-paginator>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-6">
              <h2>Inicio contrato</h2>
              <div class="row">
                <div class="col-lg-3">
                  <span>Total Alquiler:</span>
                </div>
                <div class="col-lg-3">
                  <span>{{calcularTotalesIniciales('montoTotalContrato') | currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <span>Comision:
                  </span>

                </div>
                <div class="col-lg-3">
                  <span>{{calcularTotalesIniciales('montoTotalComision') | currency}}
                    <mat-icon inline color="primary"
                      matTooltip="Comision calculada al inicio de contrato.">info</mat-icon>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <span>Sellado:
                  </span>

                </div>
                <div class="col-lg-3">
                  <span>{{calcularTotalesIniciales('montoTotalSellado') | currency}}
                    <mat-icon inline color="primary"
                      matTooltip="Sellado calculado al inicio de contrato.">info</mat-icon>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <h2>Total</h2>
                </div>
                <div class="col-lg-3">
                  <h2>{{calcularTotalesIniciales('montoTotal') | currency}}</h2>
                </div>
              </div>
            </div>
            <div class="col-6">
              <h2>Ultima actualización </h2>
              <div class="row">
                <div class="col-lg-3">
                  <span>Total Alquiler:</span>
                </div>
                <div class="col-lg-3">
                  <span>{{totalMontoAlquiler | currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <span>Comision:
                  </span>

                </div>
                <div class="col-lg-3">
                  <span>{{totalComision | currency}}
                    <mat-icon inline color="primary" matTooltip="Ultima comision calculada.">info</mat-icon>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <span>Sellado:
                  </span>

                </div>
                <div class="col-lg-3">
                  <span>{{totalSellado | currency}}
                    <mat-icon inline color="primary" matTooltip="Ultimo sellado calculado.">info</mat-icon>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <h2>Total</h2>
                </div>
                <div class="col-lg-3">
                  <h2>{{total | currency}}</h2>
                </div>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>
          <br>
          <div class="row">
            <div class="col-lg-3" matTooltip="Descuentos desde el primer periodo.">
              <span>Total Descuentos:</span>
            </div>
            <div class="col-lg-3">
              <span> {{totalDescuento | currency}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3" matTooltip="Incrementos desde el primer periodo.">
              <span>Total Incrementos:</span>
            </div>
            <div class="col-lg-3">
              <span>{{totalIncrementos | currency}}</span>
            </div>
          </div>

        </div>
      </div>

    </form>
  </mat-tab>

  <!-- Auditoría
       Tab propio y no un bloque al pie de "Detalle Montos Contrato": no tiene
       nada que ver con los montos y quedaba escondido abajo de una tabla larga.
       Con matTabContent la consulta sale recién cuando se entra al tab.

       La entidad es el nombre de la TABLA: tiene que coincidir con el que usa
       HistorialCambios o el historial sale vacío. -->
  <mat-tab *appRole="['Auditoria.Ver']">
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">history</mat-icon>&nbsp; Auditoría
    </ng-template>

    <ng-template matTabContent>
      <div class="container-mat-card">
        <app-info-auditoria *ngIf="contratoDetailDto && contratoDetailDto.id > 0"
          entidad="Contratos" [id]="contratoDetailDto.id">
        </app-info-auditoria>
      </div>
    </ng-template>
  </mat-tab>

</mat-tab-group>
